import { api } from './api';

export function listConversations() {
  return api.get('/api/chat/conversations');
}

export function createConversation(body) {
  return api.post('/api/chat/conversations', body);
}

export function getConversation(id) {
  return api.get(`/api/chat/conversations/${id}`);
}

export function listMessages(conversationId, params) {
  return api.get(`/api/chat/conversations/${conversationId}/messages`, { params });
}

export function sendMessage(conversationId, body) {
  return api.post(`/api/chat/conversations/${conversationId}/messages`, { body });
}

export function markRead(conversationId, messageId) {
  return api.post(`/api/chat/conversations/${conversationId}/read`, null, {
    params: messageId ? { message_id: messageId } : undefined,
  });
}

export function searchUsers(q) {
  return api.get('/api/chat/users/search', { params: { q } });
}

export function searchChat(q) {
  return api.get('/api/chat/search', { params: { q } });
}

export function updateMessage(messageId, body) {
  return api.put(`/api/chat/messages/${messageId}`, { body });
}
